import React, { useEffect, useMemo, useRef, useState } from "react";
import { Field, FieldArray, formValueSelector, reduxForm, submit } from "redux-form";
import { components } from "react-select";
import { connect, useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import moment from "moment";

import { customInput } from "../../../../common/custom-input";
import { CustomSingleSelect } from "../../../../common/new-core-ui/CustomSingleSelect";
import { getSwmsMethods } from "../../../../../actions/v2/SwmsMethodActions";
import { getStorage } from "../../../../../utils/common";
import { ADMIN_DETAILS } from "../../../../../dataProvider/constant";
import ActivityActionsSection from "../../../SwmsMasters/SwmsActivity/ActivityActionsSection";
import validate from "../../../SwmsMasters/SwmsActivity/ValidateAddEditSWMSActivity";

import colorStyles from "../../../v2FormSelectStyle";
import styles from "../../../v2Styles.module.css";

let AddEditJSA2ActivityForm = ({ categories, likelihoods, consequences, loading = false, loadingData, selectedCategory, handleSubmit, disabled = false, pristine, isNewActivity, goBack, initialValues, change, onActivitySubmit }) => {

  const [methods, setMethods] = useState([]);
  const [loadingMethods, setLoadingMethods] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const controller = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCategory && selectedCategory.value) {
      setMethods([]);
      const categoryId = selectedCategory.value;
      fetchCategoryMethods(categoryId);
    }
  }, [selectedCategory]);

  const fetchCategoryMethods = (categoryId) => {
    setLoadingMethods(true);
    controller.current = new AbortController();
    dispatch(getSwmsMethods({ category_id: categoryId, limit: 10000 }, { signal: controller.current.signal })).then(res => {
      setMethods(res.rows);
      setLoadingMethods(false);
    }).catch(err => {
      if (err) {
        console.log(err);
        setLoadingMethods(false);
      }
    })
  }

  const onCategoryChange = (v) => {
    change("category", v);
    change("method", null);
    setMethods([]);
    fetchCategoryMethods(v.value);
  }

  const user = useMemo(() => {
    const details = JSON.parse(getStorage(ADMIN_DETAILS));
    return details ? details : null
  }, []);

  const onSubmit = (values) => {
    setSubmitting(true);
    const userName = user ? `${user.name} ${user.last_name}` : null;
    const allActions = values.actions.map((action, actionIndex) => {
      const allHazards = action.hazards.map((hazard, hazIndex) => {
        const allConsequences = hazard.consequences.map((consequence, index) => {
          return {
            consequences_name: consequence.consequence_name,
            consequences_order: index + 1,
            ...(!consequence.isNew && consequence.id ? { consequence_id: consequence.id } : { consequence_id: Date.now() })
          }
        });
        return {
          hazard_name: hazard.hazard_name,
          activity_hazard_order: hazIndex + 1,
          fm_swms_hazards_consequences_v2: allConsequences,
          ...(hazard.id ? { hazard_id: hazard.id } : { hazard_id: Date.now() })
        }
      });
      return {
        action_name: action.action_name,
        action_order: actionIndex + 1,
        fm_swms_activities_hazards_v2: allHazards,
        action_id: action.id ? action.id : Date.now(),
        after_consequence: action.after_consequence ? { name: action.after_consequence.label, id: action.after_consequence.value, value: action.after_consequence.cons_value } : null,
        before_consequence: action.before_consequence ? { name: action.before_consequence.label, id: action.before_consequence.value, value: action.before_consequence.cons_value } : null,
        after_likelihood: action.after_likelihood ? { name: action.after_likelihood.label, id: action.after_likelihood.value, value: action.after_likelihood.like_value } : null,
        before_likelihood: action.before_likelihood ? { name: action.before_likelihood.label, id: action.before_likelihood.value, value: action.before_likelihood.like_value } : null,
        initial_risk: action.initialRisk ? action.initialRisk : null,
        residual_risk: action.residualRisk ? action.residualRisk : null,
        persons_in_control: action.persons_in_control ? action.persons_in_control : null,
        control_measures: action.control_measures ? action.control_measures : null
      }
    });

    let activityDetails = {
      activity_id: values.id ? values.id : Date.now(),
      activity_name: values.activity_name,
      category_id: values.category && values.category.value ? values.category.value : null,
      method_id: values.method && values.method.value ? values.method.value : null,
      category_name: values.category && values.category.label ? values.category.label : null,
      method_name: values.method && values.method.label ? values.method.label : null,
      description: null,
      edited: true,
      fm_swms_actions_v2: allActions,
      ...(!values.id ? {
        toggled_active: 1,
        active: 1,
        created_by: user ? user.user_name : null,
        created_by_name: userName,
        created_at: moment.utc().toISOString(),
        owner: user ? user.user_name : null,
        owner_name: userName,
        modified_by: null,
        modified_by_name: null,
        modified_at: null,
        next_review_date: null,
        approver: null,
        approver_name: null,
        approved_at: null,
        org_id: user && user.organisation && user.organisation.id ? user.organisation.id : null,
        next_review_date: null,
        status: "created",
        submitted_at: null
      } : {
        toggled_active: values.toggled_active,
        created_by: values.created_by,
        created_by_name: values.created_by_name,
        created_at: values.created_at,
        active: values.active,
        owner: values.owner,
        owner_name: values.owner_name,
        approver: values.approver,
        approver_name: values.approver_name,
        approved_at: values.approved_at,
        next_review_date: values.next_review_date,
        status: values.status,
        submitted_at: values.submitted_at,
        org_id: values.org_id,
        modified_by: user ? user.user_name : null,
        modified_by_name: userName,
        modified_at: moment.utc().toISOString(),
      })
    }
    onActivitySubmit(activityDetails);
  }

  return (
    <form>
      <div className="v2-modal-container" style={{ scrollbarGutter: "stable", height: "inherit", overflow: "hidden auto" }}>
        <div className="container-fluid px-0">
          <div className="row">
            <div className="col-12">
              <div className={styles.ModalHeading}>{isNewActivity ? "Create New Activity" : `Edit Activity${initialValues.activity_name ? ` - ${initialValues.activity_name}` : ""}`}</div>
              <div>
                <hr />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="border p-3 my-3 rounded">
                <div className="container-fluid ml-0 px-0">
                  <div className="row">
                    <div className="col-6">
                      <div className={styles.Label}>Category</div>
                      <Field
                        name="category"
                        component={CustomSingleSelect}
                        options={categories.map(x => ({ label: x.category_name, value: x.id }))}
                        otherProps={{
                          isLoading: loadingData,
                          isDisabled: loading || disabled || submitting || !isNewActivity,
                          menuPlacement: "auto",
                          hideSelectedOptions: false,
                          onChange: onCategoryChange,
                          styles: colorStyles,
                          components: { dropdownIndicator: <components.DownChevron /> }
                        }} />
                    </div>
                    <div className="col-6">
                      <div className={styles.Label}>Method</div>
                      <Field
                        name="method"
                        component={CustomSingleSelect}
                        options={methods.map(x => ({ label: x.method_name, value: x.id }))}
                        otherProps={{
                          isLoading: loadingMethods,
                          isDisabled: loading || disabled || submitting || !isNewActivity,
                          menuPlacement: "auto",
                          hideSelectedOptions: false,
                          styles: colorStyles,
                          components: { dropdownIndicator: <components.DownChevron /> }
                        }} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 pt-3">
                      <div className={styles.Label}>Activity Name</div>
                      <Field
                        name="activity_name"
                        disabled={loading || disabled || submitting}
                        autoComplete="off"
                        className={styles.TextField}
                        component={customInput} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none">
                <Field name="_v" component="input" type="hidden" />
              </div>
              <div className="border p-3 my-3 rounded">
                <div className="container-fluid px-0">
                  <div className="row">
                    <div className="col-12">
                      <FieldArray
                        name="actions"
                        loadingData={loadingData}
                        consequences={consequences}
                        likelihoods={likelihoods}
                        formName="swms_jsa_2activity_details_form"
                        loading={loading || submitting}
                        disabled={disabled}
                        component={ActivityActionsSection}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="my-3 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
                {submitting ? (
                  <CircularProgress size={20} />
                ) : null}
                <button type="button" onClick={() => goBack()} className={`${styles.OutlinedButton}`} style={{ padding: "0px 5px" }}>
                  Cancel
                </button>
                <button type="button" onClick={handleSubmit(onSubmit)} disabled={loading || disabled || pristine || submitting} className={styles.PrimaryButton}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

AddEditJSA2ActivityForm = reduxForm({
  form: "swms_jsa_2activity_details_form",
  enableReinitialize: true,
  validate: validate
})(AddEditJSA2ActivityForm);

export default connect((state) => ({
  selectedCategory: formValueSelector("swms_jsa_2activity_details_form")(state, "category"),
}))(AddEditJSA2ActivityForm)